import { InformationCircleIcon } from "@heroicons/react/24/outline";
import React from "react";

type BetaFeatureLabelProps = {
    minimal?: boolean;
    tooltip?: string;
};

export const BetaFeatureLabel: React.FC<BetaFeatureLabelProps> = ({
    minimal = false,
    tooltip = "This feature is in beta and may change based on feedback.",
}) => {
    return (
        <div className="inline-flex items-center space-x-1 relative group align-middle mt-[-2px]">
            {!minimal && (
                <span className="align-super text-[10px] leading-[1.5] font-semibold text-white bg-blue-500 px-1.5 py-0 rounded-full ml-1">
                    Beta
                </span>
            )}
            <div className="relative z-20">
                <InformationCircleIcon className="w-4 h-4 text-gray-500 hover:text-gray-700 cursor-pointer align-middle" />
                {/* Tooltip */}
                <div className="absolute left-1/2 top-full mt-1 w-56 -translate-x-1/2 transform rounded-md bg-gray-800 p-2 text-sm text-white shadow-md opacity-0 group-hover:opacity-100 pointer-events-none z-50">
                    {tooltip}
                </div>
            </div>
        </div>
    );
};
